import { LoadableLazy } from '@confluence/loadable';
import { LoadingState } from '../src/SpacesDropdownContent';

export const SpacesDropdown = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown'
			)
		).SpacesDropdown,
});
export const SpacesDropdownLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown'
			)
		).SpacesDropdown,
	loading: LoadingState,
});
